/* pdp-configurator.js — divider toggle + colour swatches for the Explorer PDP (Leak 2).

   Colourway switching is an in-place SOFT-SWAP: fetch the target colourway page,
   replace only the product section, pushState to the real (directly-enterable)
   URL. No full reload. Any failure -> normal navigation. With JS off, the divider
   toggle still carries a data-url and the swatches are plain links via fallback. */
(function () {
  'use strict';

  var SECTION_SEL = '.shopify-section';           // Shopify wraps every section
  var MARKER_SEL = '[data-pdp-gallery]';          // lives inside custom-main-product
  var swapping = false;
  var pendingUrl = null;                          // latest colour requested mid-swap
  var didSoftSwap = false;

  function currentProductPath() {
    var a = document.querySelector('[data-pdp-swatch].is-active');
    if (a) { try { return new URL(a.getAttribute('data-url'), location.href).pathname; } catch (e) {} }
    return null;
  }

  /* ---- soft swap ---------------------------------------------------- */
  function productSection(doc) {
    var m = (doc || document).querySelector(MARKER_SEL);
    return m ? m.closest(SECTION_SEL) : null;
  }

  function updateHead(doc, url) {
    try {
      if (doc.title) document.title = doc.title;
      var pairs = [
        ['link[rel="canonical"]', 'href'],
        ['meta[property="og:url"]', 'content'],
        ['meta[property="og:title"]', 'content'],
        ['meta[property="og:description"]', 'content'],
        ['meta[property="og:image"]', 'content'],
        ['meta[name="description"]', 'content'],
        ['meta[name="twitter:title"]', 'content'],
        ['meta[name="twitter:description"]', 'content'],
        ['meta[name="twitter:image"]', 'content']
      ];
      pairs.forEach(function (p) {
        var from = doc.querySelector(p[0]);
        var to = document.querySelector(p[0]);
        if (from && to) to.setAttribute(p[1], from.getAttribute(p[1]));
        else if (from && !to && from.tagName === 'LINK') document.head.appendChild(from.cloneNode(true));
      });
    } catch (e) { /* head sync is best-effort */ }
  }

  function afterSwap(url, push) {
    if (push) { try { history.pushState({ pdpSwap: 1 }, '', url); didSoftSwap = true; } catch (e) {} }
    // custom elements in the new markup upgrade on insertion; re-init our own
    document.dispatchEvent(new Event('pdp:swapped'));
    // Yotpo's buy-box star widget is swapped in empty — make Yotpo re-scan
    try {
      if (window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets) {
        window.yotpoWidgetsContainer.initWidgets();
      }
    } catch (e) {}
    // let listeners know the colourway changed (analytics / future hooks)
    document.dispatchEvent(new CustomEvent('pdp:colourchange', { detail: { url: url } }));
  }

  function hardNav(url) { window.location.assign(url); }

  /* ---- on-intent prefetch ---------------------------------------------
     The eager per-colourway <link rel=prefetch> loop pulled ~3.5 MB of
     sibling HTML on every page load. Instead, warm ONE colourway the moment
     the visitor shows intent (hover / focus / pointer-down on its swatch or
     the divider toggle). softSwap()'s own fetch still covers a cold click. */
  var warmed = Object.create(null);
  function warm(url) {
    if (!url) return;
    var abs;
    try { abs = new URL(url, location.href).href; } catch (e) { return; }
    if (warmed[abs]) return;
    if (stripHash(abs) === stripHash(location.href)) return;
    warmed[abs] = 1;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.as = 'document';
    l.href = abs;
    document.head.appendChild(l);
  }

  // The buy box / price / badges are wrapped in <xo-animate xo-cascade>, which
  // starts at opacity:0 and reveals on scroll into view. After a soft-swap the
  // new markup is already in view, so force it visible.
  function revealAnimated(scope) {
    var els = scope.querySelectorAll('xo-animate');
    for (var i = 0; i < els.length; i++) {
      els[i].removeAttribute('xo-cascade');
      els[i].style.opacity = '1';
      els[i].style.transform = 'none';
      els[i].style.visibility = 'visible';
    }
  }

  function softSwap(url, push) {
    if (swapping) { pendingUrl = url; return; }   // remember the latest tap; run it when this one finishes
    var cur = productSection();
    if (!cur || !('fetch' in window) || !('DOMParser' in window)) { hardNav(url); return; }
    swapping = true;
    cur.setAttribute('data-pdp-swapping', '');   // interaction lock, no visible change
    // only show the dim if we're still waiting after one transition-length —
    // a prefetched swap finishes well before this and never dims
    var slowDimTimer = setTimeout(function () {
      if (swapping && cur.isConnected) cur.setAttribute('data-pdp-swapping-slow', '');
    }, 150);

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        // if the server redirected somewhere unexpected, just go there
        if (r.redirected && r.url && stripHash(r.url) !== stripHash(new URL(url, location.href).href)) {
          hardNav(r.url); throw new Error('redirected');
        }
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = productSection(doc);
        var here = productSection();
        if (!next || !here) throw new Error('no product section');
        // direct replace (no startViewTransition — its abort on rapid swaps threw
        // InvalidStateError). The section is prefetched so the swap is instant;
        // [data-pdp-swapping-slow] adds a .55 dim only if a fetch runs long.
        here.replaceWith(next);
        revealAnimated(next);
        updateHead(doc, url);
        afterSwap(url, push);
      })
      .catch(function (err) {
        if (String(err && err.message) !== 'redirected') hardNav(url);
      })
      .finally(function () {
        clearTimeout(slowDimTimer);
        swapping = false;
        var s = productSection();
        if (s) { s.removeAttribute('data-pdp-swapping'); s.removeAttribute('data-pdp-swapping-slow'); }
        if (pendingUrl && pendingUrl !== location.href) {
          var u = pendingUrl; pendingUrl = null;
          softSwap(u, true);
        } else {
          pendingUrl = null;
        }
      });
  }
  function stripHash(u) { return String(u).split('#')[0]; }

  window.addEventListener('popstate', function () {
    if (!didSoftSwap) return;                       // ignore the load-time popstate
    var shown = currentProductPath();
    if (shown && shown === location.pathname) return; // already showing the right colour
    if (productSection()) softSwap(location.href, false);
  });

  /* ---- per-configurator wiring ------------------------------------- */
  function init(root) {
    if (root.__pcInit) return;
    root.__pcInit = true;

    var nameEl = root.querySelector('[data-pdp-colour-name]');
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-swatch]'));
    var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-divider-btn]'));
    var selectedName = nameEl ? nameEl.textContent.trim() : '';
    var thisDivider = root.getAttribute('data-divider');

    // remember the colour currently shown for this divider, this session, so
    // toggling away and back returns here instead of the divider default
    function remember(divider, path) { try { sessionStorage.setItem('pdp:last:' + divider, path); } catch (e) {} }
    function recall(divider) { try { return sessionStorage.getItem('pdp:last:' + divider); } catch (e) { return null; } }
    remember(thisDivider, location.pathname);

    function showDivider(d) {
      swatches.forEach(function (s) { s.hidden = s.getAttribute('data-divider') !== d; });
      root.setAttribute('data-divider', d);
      toggles.forEach(function (t) {
        var on = t.getAttribute('data-divider-btn') === d;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    showDivider(root.getAttribute('data-divider'));

    function activate(url) {
      if (!url) return;
      var abs = new URL(url, location.href).href;
      if (stripHash(abs) === stripHash(location.href)) return;
      softSwap(abs, true);
    }

    swatches.forEach(function (s) {
      var warmSwatch = function () { warm(s.getAttribute('data-url')); };
      s.addEventListener('click', function () { activate(s.getAttribute('data-url')); });
      s.addEventListener('pointerenter', warmSwatch);
      s.addEventListener('pointerdown', warmSwatch);
      s.addEventListener('mouseenter', function () { if (nameEl) nameEl.textContent = s.getAttribute('data-label'); });
      s.addEventListener('focus', function () { warmSwatch(); if (nameEl) nameEl.textContent = s.getAttribute('data-label'); });
      s.addEventListener('mouseleave', restore);
      s.addEventListener('blur', restore);
    });
    function restore() { if (nameEl) nameEl.textContent = selectedName; }

    toggles.forEach(function (t) {
      var warmToggle = function () {
        if (t.classList.contains('is-active')) return;
        var target = t.getAttribute('data-divider-btn');
        warm(recall(target) || t.getAttribute('data-default-url'));
      };
      t.addEventListener('pointerenter', warmToggle);
      t.addEventListener('pointerdown', warmToggle);
      t.addEventListener('focus', warmToggle);
      t.addEventListener('click', function () {
        if (t.classList.contains('is-active')) return;
        var target = t.getAttribute('data-divider-btn');
        activate(recall(target) || t.getAttribute('data-default-url'));
      });
    });
  }

  /* The static buy-box rating renders from a metafield Yotpo only syncs every few
     days (currently 1 behind). Once the real Yotpo widget lower on the page has
     loaded, copy its true count/average onto the static rating — no extra
     request, and the number is already visible so the correction is unobtrusive.
     Writes the value + count into the existing .pdp-rating__link spans (keeping
     the "4.8 (51)" shape and their underline) rather than replacing the count —
     so this is the single writer and no guard/observer is needed. */
  function syncRating() {
    var el = document.querySelector('.pdp-rating');
    if (!el) return;
    var starsEl = el.querySelector('.pdp-rating__stars');
    var links = el.querySelectorAll('.pdp-rating__link'); // [0] = average, [1] = count
    var tries = 0;
    (function poll() {
      if (!el.isConnected) return; // element was swapped out (colourway change) — a fresh boot() poll owns the new one
      var src = document.querySelector(
        '.yotpo-bottom-line-text, .yotpo-bottom-line-right-panel, .yotpo-bottom-line-summary, .yotpo-bottom-line'
      );
      var txt = src ? src.textContent || '' : '';
      var cm = txt.match(/([\d,]+)\s*review/i);
      if (cm) {
        var n = cm[1].replace(/,/g, '');
        var am = txt.match(/([0-5](?:\.\d+)?)\s*(?:out of|\/\s*5|based)/i) || txt.match(/(^|[^\d])([0-5]\.\d)/);
        var avg = am ? parseFloat(am[am.length - 1]) : NaN;
        var avgStr = (avg >= 0 && avg <= 5) ? String(Math.round(avg * 10) / 10) : null;

        if (links.length >= 2) {
          if (avgStr) links[0].textContent = avgStr;
          if (n) links[1].textContent = n;
        } else if (links.length === 1 && n) {
          links[0].textContent = n; // markup variant without the average link
        }
        if (starsEl && avg >= 0 && avg <= 5) starsEl.style.setProperty('--pct', (avg / 5 * 100) + '%');

        // keep the a11y label matching what's now shown
        var shownAvg = links[0] ? links[0].textContent.trim() : '';
        if (n) {
          el.setAttribute(
            'aria-label',
            'Rated ' + shownAvg + ' out of 5 stars, ' + n + ' review' + (n === '1' ? '' : 's')
          );
        }
        return;
      }
      if (++tries < 40) setTimeout(poll, 400);
    })();
  }

  function boot() {
    var list = document.querySelectorAll('[data-pdp-config]');
    for (var i = 0; i < list.length; i++) init(list[i]);
    syncRating();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('pdp:swapped', boot);
})();
